export enum DROPDOWN_NAME {
    Company = "company",
    Group = "group"
}
